export default __webpack_public_path__ + "static/media/parent_avatar.cd29f364.png";